import React from 'react';
import CodeVerificationView from '../code-verification-view';

export interface SmsVerificationViewProps {
  maskedPhone: string;
  isVerifying?: boolean;
  verificationError?: boolean;
  cooldownSeconds?: number;
  showTooManyAttempts?: boolean;
  onVerify: (code: string) => void | Promise<void>;
  onClearError: () => void;
  onResendCode: () => Promise<void>;
  onUseEmailVerification: () => void | Promise<void>;
  onChangeEmail: () => void;
  onUsePasswordVerification: () => void;
}

const SmsVerificationView = ({
  maskedPhone,
  isVerifying = false,
  verificationError = false,
  cooldownSeconds = 0,
  showTooManyAttempts = false,
  onVerify,
  onClearError,
  onResendCode,
  onUseEmailVerification,
  onChangeEmail,
  onUsePasswordVerification,
}: SmsVerificationViewProps): React.ReactElement => (
  <CodeVerificationView
    channel="sms"
    destination={maskedPhone}
    isVerifying={isVerifying}
    verificationError={verificationError}
    cooldownSeconds={cooldownSeconds}
    showTooManyAttempts={showTooManyAttempts}
    onVerify={onVerify}
    onClearError={onClearError}
    onResendCode={onResendCode}
    onUseAlternateChannel={onUseEmailVerification}
    onChangeEmail={onChangeEmail}
    onUsePasswordVerification={onUsePasswordVerification}
  />
);

export default SmsVerificationView;
